import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;

// Checkout config set on the server: flat-rate shipping and whether Local Meetup is offered.
export const useCheckoutConfig = () => {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/checkout-config").then((r) => { cached = r.data.shipping_cents; setConfig(r.data); }).catch(() => {});
  }, []);
  return config;
};

// Flat-rate shipping set on the server, fetched once per visit.
export const useShipping = () => {
  const [cents, setCents] = useState(cached);
  useEffect(() => {
    if (cached !== null) return;
    api.get("/checkout-config").then((r) => { cached = r.data.shipping_cents; setCents(cached); }).catch(() => {});
  }, []);
  return cents;
};

export const orderTotal = (o) => o.total_cents || o.subtotal_cents;
